/* eslint-disable react/jsx-props-no-spreading */
import { CircularProgress, IconButton, makeStyles } from "@material-ui/core";
import { Delete, Description as DescriptionIcon } from "@material-ui/icons";
import React from "react";
import Dropzone from "react-dropzone";

const useStyles = makeStyles(theme => ({
  root: {
    position: "relative",
    overflow: "hidden",
    width: "256px",
    height: "144px",
    border: "solid 1px",
    borderColor: theme.palette.primary.main,
    cursor: "pointer",
    borderRadius: "8px",
    "&:hover": {
      borderColor: "#63aec7",
      "& > :last-child": {
        opacity: 1
      }
    }
  },
  image: {
    height: "100%",
    width: "100%"
  },
  imageIcon: {
    opacity: 0.5,
    display: "block",
    position: "absolute",
    top: "calc(50% - 0.7rem)",
    left: "calc(50% - 0.7rem)",
    color: theme.palette.primary.main
  },
  trashButton: {
    opacity: 0,
    position: "absolute",
    top: "calc(50% - 1.8rem)",
    left: "calc(50% - 1.8rem)"
  },
  trashIcon: {
    fontSize: "2rem",
    color: "#B80011"
  },
  loader: {
    position: "absolute",
    top: "calc(50% - 40px)",
    left: "calc(50% - 40px)"
  }
}));

const FileUploader = ({
  imageUrl,
  imageAlt,
  loading,
  onFileUpload,
  icon: Icon = DescriptionIcon,
  accept
}) => {
  const classes = useStyles();

  if (loading) {
    return (
      <div className={classes.root}>
        <CircularProgress size={80} className={classes.loader} />
      </div>
    );
  }
  if (imageUrl) {
    return (
      <div className={classes.root}>
        <img alt={imageAlt} src={imageUrl} className={classes.image} />
        <IconButton
          className={classes.trashButton}
          onClick={() => {
            onFileUpload({ file: null });
          }}
        >
          <Delete className={classes.trashIcon} />
        </IconButton>
      </div>
    );
  }

  return (
    <Dropzone
      accept={accept}
      maxSize={1000000}
      multiple={false}
      onDrop={acceptedFiles => {
        onFileUpload({ file: acceptedFiles[0] });
      }}
    >
      {({ getRootProps, getInputProps }) => (
        <div {...getRootProps()} className={classes.root}>
          <Icon className={classes.imageIcon} />
          <input {...getInputProps()} />
        </div>
      )}
    </Dropzone>
  );
};

export default FileUploader;
